<template>
  <pop-up-layout 
    :mini="true"
    :title="$t('popUpAddModulos.seleccioneModulos')"
    :aceptar="$t('popUpAddModulos.addModulos')"
    :disabled="noHaySeleccionados"
    @volver="$parent.hide()"
    @aceptar="addModulos()"
  >
    <div v-if="!waitingForLoad">
      <v-card
        :class="['pa-1', 'ma-2', 'modulo-base-item']"
        v-for="(modulo, index) in modulosBase"
        :key="index + '-popup'"
      >
        <v-card>
          <v-layout row justify-start align-center>
            <v-flex shrink>
              <v-checkbox
                color="primary" class="pl-2" 
                v-model="modulo.seleccionado"
                :disabled="!modulo.disponible"
              />
            </v-flex>
            <o-tint-img
              class="modulo-image"
              :src="require('@/assets/images/reserva/' + modulo.tipo + '.jpg')"
            />
            <span :class="['modulo-text', 'pl-2', modulo.disponible && modulo.seleccionado ? 'primary--text' : 'grey--text']">
              {{getNombreModulo(modulo.tipo)}}
            </span>
          </v-layout>
        </v-card>
        <v-card v-if="modulo.tipo === 'kyc'" class="mt-2">
          <v-layout row justify-start align-center>
            <v-flex shrink>
              <v-checkbox
                style="opacity: 0" class="pl-2"
                disabled
              />
            </v-flex>
            <o-tint-img
              class="modulo-image"
              :src="require('@/assets/images/reserva/' + moduloDocumentacionBase.tipo + '.jpg')"
            />
            <span :class="['modulo-text', 'pl-2', modulo.disponible && modulo.seleccionado ? 'primary--text' : 'grey--text']">
              {{getNombreModulo('documentacion')}}
            </span>
          </v-layout>
        </v-card>
      </v-card>
    </div>
  </pop-up-layout>
</template>

<script>
export default {
  props: {
    modulos: {
      type: Array,
      default: () => []
    },
    moduloDocumentacion: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      modulosBase: [],
      moduloDocumentacionBase: {},
      waitingForLoad: true
    }
  },
  created () {
    this.waitingForLoad = true
    this.moduloDocumentacionBase = Object.assign({}, this.moduloDocumentacion)
    this.modulosBase = this.modulos.map(x => {
      return {
        ...x,
        seleccionado: !x.disponible
      }
    })
    this.waitingForLoad = false
  },
  computed: {
    noHaySeleccionados () {
      return this.modulosBase.filter(x => x.disponible).every(x => !x.seleccionado)
    }
  },
  methods: {
    getNombreModulo(tipo) {
      return this.getTexto('modulos.' + tipo + (this.alquiler ? 'Alquiler' : ''))
    },
    addModulos () {
      this.$emit('add', this.modulosBase.filter(x => { return x.disponible && x.seleccionado }))
    }
  }
}
</script>

<style lang="stylus" scoped>
  @require '~vuetify/src/stylus/settings/_colors'

.modulo-base-item
  background-color: $grey["lighten-4"] !important;
  .modulo-image
    height: 40px
    width: 60px
    max-width: 60px
  .modulo-text
    font-size: small
    font-weight: bold  
</style>


// WEBPACK FOOTER //
// src/components/configuracion/PopUpAddModulos.vue